"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNetworkErrorHandlers = void 0;
var react_1 = require("react");
var NetworkRequestContext_1 = require("../context/NetworkRequestContext");
var useNetworkErrorHandlers = function () {
    var globalErrorCallback = (0, react_1.useContext)(NetworkRequestContext_1.NetworkRequestContext).globalErrorCallback;
    var mutationsErrorHandler = (0, react_1.useCallback)(function (_a) {
        var key = _a.key, mutation = _a.mutation, params = _a.params, error = _a.error, options = _a.options, context = _a.context, onError = _a.onError;
        globalErrorCallback === null || globalErrorCallback === void 0 ? void 0 : globalErrorCallback({ key: key, mutation: mutation, params: params, error: error, options: options, context: context, onError: onError, requestType: "mutation" });
        //react-query hook instance onError();
        onError === null || onError === void 0 ? void 0 : onError(error, params, context);
    }, [globalErrorCallback]);
    var queriesErrorHandler = (0, react_1.useCallback)(function (_a) {
        var key = _a.key, refetch = _a.refetch, error = _a.error, options = _a.options, onError = _a.onError;
        globalErrorCallback === null || globalErrorCallback === void 0 ? void 0 : globalErrorCallback({
            key: key,
            refetch: refetch,
            error: error,
            options: options,
            onError: onError,
            requestType: "query",
        });
        //react-query hook instance onError();
        onError === null || onError === void 0 ? void 0 : onError(error);
    }, [globalErrorCallback]);
    return {
        mutationsErrorHandler: mutationsErrorHandler,
        queriesErrorHandler: queriesErrorHandler,
    };
};
exports.useNetworkErrorHandlers = useNetworkErrorHandlers;
